<template>
	<el-row class="mainOnebox">
		<!-- 标题 -->
		<el-row class="mainOnebox_title">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>PRODUCT</el-breadcrumb-item>
				<el-breadcrumb-item>Tactile Indicator</el-breadcrumb-item>
			</el-breadcrumb>
		</el-row>
		<!-- 内容 -->
		<el-row class="mainOnebox_main">
			<div class="mainOnebox_main_list_remove" v-for="(item,i) in imgdata" :key="i" @click="routelist(i)" @mouseenter="changeActive($event)" @mouseleave="removeActive($event)">
				<img :src="item.url">
				<span class="mainOnebox_main_list_name">{{item.title}}</span>
			</div>
			<div class="mainOnebox_main_list_none"></div>
			<div class="mainOnebox_main_list_none"></div>
		</el-row>
	</el-row>
</template>

<script>
	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {
				imgdata: [
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1314.jpg'),title: 'HZ-T1314',list1:'35*25*4.5mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Carborundum Insert',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1322.jpg'),title: 'HZ-T1322',list1:'35*25*4.5mm + φ5*10mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Reflection plate insert',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1326.jpg'),title: 'HZ-T1326',list1:'25*4.5mm + φ5*18mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Concentric Circles',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1329.jpg'),title: 'HZ-T1329',list1:'35*25*4.5mm + φ6*13mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Luminescent Plate Insert',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1340.jpg'),title: 'HZ-T1340',list1:'35*25*4.5mm + φ6*13mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Carborundum Insert with Injection Stem',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1442.jpg'),title: 'HZ-T1442',list1:'25*10*4.5mm + φ5*10mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Spiricle',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1443B.jpg'),title: 'HZ-T1443B',list1:'35*25*4.5mm + φ6*13mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Smooth Surface',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1463.jpg'),title: 'HZ-T1463',list1:'35*25*4.5mm + φ6*13mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Plastic Plate Insert',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1472.jpg'),title: 'HZ-T1472',list1:'25*4.5mm + φ8*13mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Spiricle',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1494.jpg'),title: 'HZ-T1494',list1:'35*25*4.5mm + φ6*13mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Etching Pattern',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1496.jpg'),title: 'HZ-T1496',list1:'25*20*5.5mm + φ10*18mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Square / Crossing',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1503.jpg'),title: 'HZ-T1503',list1:'25*13*4.5mm + φ6*13mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Diamond / Sunflower',list4:'Milling Finish',list5:'Casting',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1505.jpg'),title: 'HZ-T1505',list1:'35*25*4.5mm + φ6*15mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Reflection plate insert',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1513.jpg'),title: 'HZ-T1513',list1:'45*4.2mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Smooth Surface',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1516.jpg'),title: 'HZ-T1516',list1:'35*25*4.5mm + φ6*20mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Concentric Circles',list4:'PVD Coating',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1519.jpg'),title: 'HZ-T1519',list1:'35*25*4.5mm + φ6*15mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Diamond / Sunflower',list4:'Milling Finish',list5:'Machine Cut / Hollow Back',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1542.jpg'),title: 'HZ-T1542',list1:'26*15*4.5mm + φ6*15mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Hole in Middle',list4:'Milling Finish',list5:'Casting / Hollow Back',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T1548.jpg'),title: 'HZ-T1548',list1:'35*25*4.5mm',list2:'304 / 316 / 316L Stainless Steel',list3:'Concentric Circles with PU Ring',list4:'Milling Finish',list5:'Machine Cut',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T2002.jpg'),title: 'HZ-T2002',list1:'35*25*4.5mm + φ6*15mm',list2:'Brass',list3:'Concentric Circles',list4:'Milling Finish',list5:'Forge and Stamp',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactileIndicator/HZ-T4001.jpg'),title: 'HZ-T4001',list1:'35*25*4.5mm + φ6*20mm',list2:'PU / ABS / Nylon / PVC',list3:'Concentric Circles',list4:'Fans Pattern',list5:'Injection',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
				],
				imgDatalis:2,//是从哪个分类进来的
			}
		},
		created() {
			this.setSessionData()
		},
		methods: {
			routelist(i) {
				this.$router.push({
					path: '/productList',
					query: {
						id: i,
						imgDataIndex:this.imgDatalis,//是从哪个分类进来的
					}
				})
			},
			changeActive(e) {
				e.currentTarget.className = 'mainOnebox_main_list';
			},
			removeActive(e) {
				e.currentTarget.className = 'mainOnebox_main_list_remove';
			},
			setSessionData(){
				sessionStorage.setItem('imgData'+this.imgDatalis,JSON.stringify(this.imgdata))
			}
		},

	}
</script>

<style lang="less" scoped>
	@vw: 19.2vw;

	.mainOnebox {
		background: url(~@/assets/image/home/home_bg1.jpg);

		.mainOnebox_title {
			width: 100%;
			padding-left: 7vw;
			margin: 0 auto;
			title-align: center;
			margin-top: 80/@vw;
			margin-bottom: 50/@vw;

			/deep/.el-breadcrumb {
				font-size: 24/@vw;
			}
		}

		.mainOnebox_main {
			max-width: 1530px;
			margin: 0 auto;
			height: auto;
			padding-bottom: 100/@vw;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;

			.mainOnebox_main_list {
				width: 350px;
				height: 350px;
				margin: 1vh 1.5vw;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 350px;
					height: 350px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					position: absolute;
					bottom: 0;
					height: 100%;
					width: 100%;
					font-weight: 700;
					color: #fafafa;
					width: 100%;
					z-index: 999;
					left: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					background-color: #000000;
					background-color: rgba(51, 51, 51, 0.5);
					font-size: 20px;
					transition: all 0.5s ease 0s;
					cursor: pointer;
				}
			}
			.mainOnebox_main_list_remove {
				width: 350px;
				height: 350px;
				margin: 1vh 1.5vw;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 350px;
					height: 350px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					display: none;
				}
			}
			.mainOnebox_main_list_none {
				width: 350px;
				margin: 1vh 1.5vw;
				height: 0px;
			}
		}
	}
</style>
